import { render, staticRenderFns } from "./mb.vue?vue&type=template&id=c64b4fec&scoped=true&"
import script from "./mb.vue?vue&type=script&lang=js&"
export * from "./mb.vue?vue&type=script&lang=js&"
import style0 from "./mb.vue?vue&type=style&index=0&id=c64b4fec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64b4fec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Imglazy: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/Imglazy.vue').default})
